import React from "react";
import { Grid } from "@mui/material";

import { FileUpload } from "../../../../components";

export default function FileComponent({ formikProps }) {
  return (
    <Grid size={12}>
      <FileUpload
        name={formikProps.values.name}
        label={formikProps.values.label}
        formikProps={formikProps}
        maxSize={formikProps.values.allowedSize}
        allowedExtension={formikProps.values.allowedExtension}
      />
    </Grid>
  );
}
